import { ReactNode, useEffect, useState } from "react"

/**
 * Defers rendering of children until after client mount. Use this around
 * components that call usePaginatedQuery/useSuspenseQuery — those hooks
 * deliberately throw a synthetic DYNAMIC_SERVER_USAGE error when they run
 * during SSR without prefetched data, which this app's Pages Router setup
 * has no graceful way to catch.
 */
export function ClientOnly({
  children,
  fallback = null,
}: {
  children: ReactNode
  fallback?: ReactNode
}) {
  const [mounted, setMounted] = useState(false)
  useEffect(() => setMounted(true), [])
  if (!mounted) return <>{fallback}</>
  return <>{children}</>
}

export default ClientOnly
